export default __webpack_public_path__ + "static/media/iconsin.593e5061.png";